export const COMMERCIAL_PRICING = {
  currency: 'SEK' as const,
  interval: 'month' as const,
  unit: 'licence' as const,
  amountExVatSek: 999,
  vatRatePercent: 25,
  amountIncVatSek: 1248.75,
  trialDays: 7,
  dunningGraceDays: 7,
} as const;

export const COMMERCIAL_LEGAL_ENTITY = {
  name: 'Forge IT Solutions AB',
  orgNumber: '559502-1923',
  address: 'Långstorp Södragården 1, 33177 Rydaholm',
} as const;

/** Public site chrome. Empty legal URLs hide those footer links until copy is published. */
export const COMMERCIAL_SITE = {
  canonicalOrigin: 'https://smidly.se',
  termsUrl: 'https://smidly.se/terms',
  privacyUrl: 'https://smidly.se/privacy',
  contactEmail: 'thommy@forge-it.se',
  contactPhone: '' as string,
  legalEntity: COMMERCIAL_LEGAL_ENTITY,
} as const;
